import { CommonModule, UpperCasePipe } from "@angular/common";
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Router } from "@angular/router";
import { EnvironmentService, TranslateService } from "@services";
import { DisableLightThemeDirective } from "src/app/core/directive/disable-light-theme.directive";
import { Language } from "src/app/transloco.config";
import { SvgIconComponent } from "../social-icons/svg-icon/svg-icon.component";

@Component({
  selector: "app-language-dropdown",
  standalone: true,
  imports: [UpperCasePipe, CommonModule, DisableLightThemeDirective, SvgIconComponent],
  templateUrl: "./language-dropdown.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./language-dropdown.component.scss"],
})
export class LanguageDropdownComponent implements OnInit {
  public selectedLanguage: Language = Language.EN;
  public isMenuOpen: boolean = false;
  @Input() public isSignInPage: boolean = false;
  @Input() public enableLightTheme: boolean = false;
  @Input() public openAbove: boolean = false;

  public availableLanguages: { code: Language }[] = [
    { code: Language.EN },
    { code: Language.ES },
    { code: Language.PL },
    { code: Language.DE },
  ];

  constructor(
    private _translateService: TranslateService,
    private _router: Router,
    private _environmentService: EnvironmentService,
    private _renderer: Renderer2,
    private _elementRef: ElementRef,
  ) {}

  public ngOnInit(): void {
    this.selectedLanguage = this._translateService.getSelectedLanguage();
  }

  public get dropdownClass(): string {
    return this.isSignInPage ? "sign-in-page" : "not-sign-in";
  }

  @HostListener("document:click", ["$event"])
  public onDocumentClick(event: MouseEvent): void {
    if (this.isMenuOpen && !this._elementRef.nativeElement.contains(event.target)) {
      this._closeMenu();
    }
  }

  public toggleMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.isMenuOpen = !this.isMenuOpen;
    if (this.isMenuOpen) {
      this._renderer.addClass(document.body, "language-dropdown-open");
    } else {
      this._renderer.removeClass(document.body, "language-dropdown-open");
    }
  }

  public changeLanguage(language: Language): void {
    this._closeMenu();
    this._translateService.setLanguage(language);
    this.selectedLanguage = language;

    let currentPath: string = this._router.url;

    currentPath = currentPath.replace(/^\/(en|de|pl|pt|es)/, "");

    this._router.navigate([`/${language}${currentPath}`]).then(() => {
      window.location.reload();
    });
    this._updateHreflang();
  }

  private _closeMenu(): void {
    this.isMenuOpen = false;
    this._renderer.removeClass(document.body, "language-dropdown-open");
  }

  private _updateHreflang(): void {
    const language: Language = this._translateService.getSelectedLanguage();
    const link: HTMLLinkElement = this._renderer.createElement("link");
    link.setAttribute("rel", "alternate");
    link.setAttribute("hreflang", language);
    link.setAttribute("href", `${this._environmentService.getHostname()}/${language}`);

    const existingLink: Element | null = document.querySelector("link[rel='alternate']");
    if (existingLink) {
      existingLink.remove();
    }

    this._renderer.appendChild(document.head, link);
  }
}
